<template>
  <router-view />
  <PeerStream :videoId="ueServer" v-if="isPeerStream"></PeerStream>
  <DbBrowser v-if="!isPeerStream"></DbBrowser>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import PeerStream from './baseCpm/peerStream/PeerStream';
import DbBrowser from './baseCpm/dbBrowser/DbBrowser';

import { clientWidth, clientHeight, isAdapt, isPeerStream, ueServer } from '@/util/config';
import { useOverViewStore } from '@/store';
import { storeToRefs } from 'pinia';
const store = useOverViewStore();
const { percents } = storeToRefs(store);

let dom = document.getElementById('app');
let sizeW = clientWidth;
let sizeH = clientHeight;
const resize = () => {
  if (isAdapt == false) {
    return;
  } else {
    let width = window.innerWidth;
    let height = window.innerHeight;
    let zoomW = width / sizeW;
    let zoomH = height / sizeH;
    let zoom = zoomW < zoomH ? zoomW : zoomH;
    dom.style.transform = `scale(${zoom}) translate(-50%, -50%)`;
    dom.style.transformOrigin = '0 0';
    dom.style.left = '50%';
    dom.style.top = '50%';
    percents.value = zoom;
  }
};
resize();

onMounted(() => {
  console.log('查看提交');
  window.addEventListener('resize', resize);
});

onBeforeUnmount(() => {
  // 移除绑定的listenResizeFn事件监听
  window.removeEventListener('resize', resize);
});
</script>

<style lang="scss">
@import url(@/assets/css/index.css);

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  width: 1920px;
  height: 1080px;
  position: absolute;
  top: 0px;
  overflow: hidden;
}
</style>
